import Swal from "sweetalert2";

export default {
    data() {
        return {}
    },
    methods: {
        showQuotaError(title = 'Insufficient plan!', text = 'You do not have enough quota for this transaction', icon = 'error') {
            Swal.fire({
                title: title,
                html: text,
                icon: icon,
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: 'Upgrade Your Plan'
            }).then(result => {
                if (result.value) {
                    this.$router.push({name: 'pricing'})
                }
            });
        },
    }
}
